import Swiper from 'swiper/bundle';

const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        slidesPerView: "auto",
        loop: false,
        navigation: {
            nextEl: `.video-slider-swiper-button-next-${sliderIdentifier}`,
            prevEl: `.video-slider-swiper-button-prev-${sliderIdentifier}`
        },
    });
}

const allSliders = $('.video-slider-type-2 .swiper-container');
allSliders.each((index, element) => buildSwiperSlider(element));